import { render, staticRenderFns } from "./DictionaryAliasInput.vue?vue&type=template&id=4ee5aad7&scoped=true&"
import script from "./DictionaryAliasInput.vue?vue&type=script&lang=ts&"
export * from "./DictionaryAliasInput.vue?vue&type=script&lang=ts&"
import style0 from "./DictionaryAliasInput.vue?vue&type=style&index=0&id=4ee5aad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee5aad7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem,VListItemContent,VListItemTitle})
